<template>
  <div>
    <div class="tfam-table-search">
      <span class="ti-search"></span>
      <input class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
    </div>
    <table class="table tfam-table" :class="tableClass">
      <thead>
      <!--
      <slot name="columns">
        <th v-for="column in columns" :key="column">{{column}}</th>
      </slot>
      -->
      </thead>
      <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td v-for="(column, index) in columns"
              :key="index"
              :Width="columnsWidth[index]"
              v-if="hasValue(item, column)">
            <span class="text">{{itemValue(item, column)}}</span>
          </td>
        </slot>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'tfam-table',
  props: {
    columns: Array,
    data: Array,
    columnsWidth: Array,
    type: {
      type: String, // striped | hover
      default: "striped"
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    search: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};
</script>
<style lang="scss">
  .tfam-table {
    margin-bottom: 0 !important;
  }
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .tfam-table-search {
    width: 100%;
    display: flex;
    list-style: none;
    padding: 20px;
    background: white;
    height: 80px;
    span {
      font-size: 15pt;
      line-height: 40px;
    }
    input {
      font-size: 15pt;
      line-height: 40px;
      height: 40px;
      background: white;
    }
  }
</style>
